import React from 'react';
import { FunctionPortDefinition } from '@glueapp/graph-types';

interface MissingPortsInfoProps {
    missingInputs: FunctionPortDefinition[];
    missingOutputs: FunctionPortDefinition[];
}

export const MissingPortsInfo: React.FC<MissingPortsInfoProps> = ({ missingInputs, missingOutputs }) => {
    if (missingInputs.length === 0 && missingOutputs.length === 0) {
        return null;
    }

    return (
        <div className="mt-2 p-2 bg-orange-50 dark:bg-orange-950/30 border border-orange-200 dark:border-orange-800 rounded text-xs">
            <div className="font-medium text-orange-700 dark:text-orange-300 mb-1">Missing ports:</div>
            {missingInputs.length > 0 && (
                <div className="text-orange-600 dark:text-orange-400">Inputs: {missingInputs.map(p => p.name).join(', ')}</div>
            )}
            {missingOutputs.length > 0 && (
                <div className="text-orange-600 dark:text-orange-400">Outputs: {missingOutputs.map(p => p.name).join(', ')}</div>
            )}
        </div>
    );
};
